import { useEffect, useState } from "react";
import { Trash2, MailWarning } from "lucide-react";
import { toast } from "sonner";
import { api, formatDate } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const STATUSES = [
  { id: "nuovo", label: "Nuovo" },
  { id: "in_lavorazione", label: "In lavorazione" },
  { id: "completato", label: "Completato" },
];

export default function QuotesManager() {
  const [quotes, setQuotes] = useState([]);

  const load = () => api.get("/admin/quotes").then((r) => setQuotes(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.patch(`/admin/quotes/${id}`, { status }).catch(() => {});
    load();
  };

  const del = async (id) => {
    await api.delete(`/admin/quotes/${id}`).catch(() => {});
    toast.success("Richiesta eliminata");
    load();
  };

  return (
    <section data-testid="quotes-manager">
      <h2 className="font-serif text-3xl text-forest">Richieste di preventivo</h2>
      <p className="mt-2 text-sm text-sage">Le richieste inviate dalla scheda contatti del sito.</p>
      <div className="mt-8 flex flex-col gap-4">
        {quotes.map((q) => (
          <div key={q.id} className="rounded-sm border border-line bg-bone p-6" data-testid={`quote-row-${q.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <p className="font-serif text-xl text-forest">{q.name}</p>
                <p className="mt-1 text-sm text-sage">{q.email}{q.phone ? ` · ${q.phone}` : ""}</p>
                <p className="mt-1 font-accent text-[10px] uppercase tracking-[0.2em] text-terra">{q.service} · {formatDate(q.created_at)}</p>
              </div>
              <div className="flex items-center gap-3">
                {!q.email_sent && (
                  <span className="flex items-center gap-1.5 text-[11px] text-sage" title="Notifica email non attiva (chiave Resend non configurata)">
                    <MailWarning className="h-3.5 w-3.5" /> email non inviata
                  </span>
                )}
                <Select value={q.status} onValueChange={(v) => setStatus(q.id, v)}>
                  <SelectTrigger className="w-44 border-line bg-sand/70 text-forest" data-testid={`quote-status-${q.id}`}>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {STATUSES.map((s) => <SelectItem key={s.id} value={s.id}>{s.label}</SelectItem>)}
                  </SelectContent>
                </Select>
                <button onClick={() => del(q.id)} className="rounded-full border border-line p-2 text-destructive hover:bg-sand" data-testid={`quote-delete-${q.id}`} aria-label="Elimina">
                  <Trash2 className="h-3.5 w-3.5" />
                </button>
              </div>
            </div>
            <p className="mt-4 border-t border-line/60 pt-4 text-sm leading-relaxed text-forest/80">{q.message}</p>
          </div>
        ))}
        {quotes.length === 0 && (
          <p className="rounded-sm border border-line bg-bone px-5 py-10 text-center text-sage" data-testid="quotes-empty">Nessuna richiesta di preventivo per ora.</p>
        )}
      </div>
    </section>
  );
}
